import { Visibility } from "@mui/icons-material";
import { Button } from "@mui/material";
import dayjs from "dayjs";
import { Athlete } from "graphql/generated/types";
import { Link, useLocation } from "react-router-dom";
import { SHORT_DATE } from "../../../../../../../utils/dates";
import { DialogSection } from "../../../../../../layout/dialogs/athlete/DialogSection";
import { useLocalizationContext } from "../../../../../../providers/LocalizationProvider";
import { T } from "../../../../../../util/t";
import { getPropertyValue, mapProperties } from "./mapProperties";

const join = (array: string[]) => array.filter((v) => v).join(", ");

interface AthleteDetailsProps {
    title?: string;
    athlete: Athlete;
    athleteProperties?: any[];
    userProperties?: any[];
    isTeams?: boolean;
}

export const AthleteDetails = ({
    athlete,
    athleteProperties = [],
    userProperties = [],
    isTeams,
}: AthleteDetailsProps) => {
    const { translate } = useLocalizationContext();
    const { pathname } = useLocation();

    if (!athlete) return null;

    const athletePropertyMapper = mapProperties(athlete, translate);
    const users = athlete.users || [];

    return (
        <DialogSection
            action={
                <Button
                    to={{
                        pathname: `/athletes/${athlete.id}`,
                        state: { from: pathname },
                    }}
                    component={Link}
                    startIcon={<Visibility fontSize="small" />}
                >
                    <T>View</T>
                </Button>
            }
            title={isTeams ? "Team details" : "Athlete details"}
            fields={[
                { label: "Name", value: athlete.name },
                !isTeams && {
                    label: "Date of birth",
                    value: athlete.dob && dayjs(athlete.dob).format(SHORT_DATE),
                },
                ...athleteProperties?.map(athletePropertyMapper),
                {
                    label: "Email",
                    value: join(users.map((user: any) => user.email)),
                },
                {
                    label: "Contact phone number",
                    value: join(users.map((user: any) => user.phone)),
                },
                ...userProperties.map((property) => ({
                    uuid: property.uuid,
                    label: property.label,
                    value: join(
                        users.map((user: any) =>
                            getPropertyValue(user, property, translate),
                        ),
                    ),
                })),
            ].filter((f) => f)}
        ></DialogSection>
    );
};
